<template>
  <div class="form-steps col-md-7 col-lg-8 p-0">
    <template v-for="(step, i) in stepsList">
      <div
        v-if="i !== stepType.ADDITIONAL_INFO && (isGuest || i !== stepType.LOGIN)"
        :key="i"
        class="step"
        :class="[currentStep === i ? 'step--active' : '', isStepDone(i) ? 'step--done' : '']"
        @click="isStepDone(i) && handleStepChange(i)"
      >
        <span class="step__index"></span>
        <span class="step__name">{{ step }}</span>
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'FormSteps',
  computed: {
    ...mapState({
      stepsList: state => state.steps.stepsList,
      currentStep: state => state.steps.currentStep,
      stepType: state => state.steps.stepType,
      isGuest: state => state.cart.userIsGuest,
    }),
  },
  methods: {
    isStepDone(i) {
      return this.currentStep > i;
    },
    handleStepChange(i) {
      this.$emit('stepChange', i);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
